export default "__VITE_ASSET__CX8ftYu0__"